import { ReactElement } from 'react';
import { IconDefinition } from '@fortawesome/free-brands-svg-icons';

import {
  freeBrandsSvgIcons,
  proDuotoneSvgIcons,
  proLightSvgIcons,
  proRegularSvgIcons,
  proSolidSvgIcons,
} from './fontAwesome';
import { customIcons } from './customIcons';

const iconsMap = {
  ...freeBrandsSvgIcons,
  ...proDuotoneSvgIcons,
  ...proLightSvgIcons,
  ...proRegularSvgIcons,
  ...proSolidSvgIcons,
  ...customIcons,
} as const;
const icons = iconsMap as {
  [iconName in keyof typeof iconsMap]: IconDefinition & { nxtCustom?: boolean; iconDom?: ReactElement };
};

type IconName = keyof typeof icons;

if (process.env.NODE_ENV !== 'production') {
  const checkForDuplicatedKeys = () => {
    [proLightSvgIcons, proRegularSvgIcons, proSolidSvgIcons, customIcons]
      .map(Object.keys)
      .reduce<{ [Name in IconName]?: boolean }>((allIconsNames, iconsNames: IconName[]) => {
        iconsNames.forEach((iconName) => {
          if (allIconsNames[iconName]) {
            throw new Error(
              `An icon is already registered with the name ${iconName}. Please use a different identifier.`,
            );
          } else {
            allIconsNames[iconName] = true;
          }
        });
        return allIconsNames;
      }, {});
  };

  checkForDuplicatedKeys();
}

const Icons = Object.keys(icons).reduce(
  (Icons, key) => ({
    ...Icons,
    [key]: key,
  }),
  {},
) as { [Name in IconName]: Name };

export type { IconName };
export { icons, Icons };
